// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/vercel/path0/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/LoadingTemp';

export function getRoutes() {
  const routes = [
  {
    "path": "/tailwind-demo",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'common__components__TailwindDemo' */'@/common/components/TailwindDemo'), loading: LoadingComponent}),
    "title": "Tailwind CSS Demo",
    "exact": true
  },
  {
    "path": "/login",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'modules__auth__pages__login__index' */'@/modules/auth/pages/login/index'), loading: LoadingComponent}),
    "title": "Se connecter à Optivest",
    "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/common/utils/auth'), loading: LoadingComponent})],
    "exact": true
  },
  {
    "path": "/auth/google/callback",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'modules__auth__pages__auth__googleCallback' */'@/modules/auth/pages/auth/googleCallback'), loading: LoadingComponent}),
    "title": "Google Authentication",
    "exact": true
  },
  {
    "path": "/auth/callback",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'modules__auth__pages__auth__tokenCallback' */'@/modules/auth/pages/auth/tokenCallback'), loading: LoadingComponent}),
    "title": "Authentication",
    "exact": true
  },
  {
    "path": "/resetPassword",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'modules__auth__pages__resetPassword' */'@/modules/auth/pages/resetPassword'), loading: LoadingComponent}),
    "title": "Mot de passe oublié",
    "exact": true
  },
  {
    "path": "/register",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'modules__auth__pages__register__index' */'@/modules/auth/pages/register/index'), loading: LoadingComponent}),
    "title": "Créer mon compte",
    "exact": true
  },
  {
    "path": "/diagnosis",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'modules__forms__pages__diagnosis' */'@/modules/forms/pages/diagnosis'), loading: LoadingComponent}),
    "title": "Diagnostic Optivest",
    "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/common/utils/authForm'), loading: LoadingComponent})],
    "exact": true
  },
  {
    "path": "/legalForm",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'modules__forms__pages__legalForm' */'@/modules/forms/pages/legalForm'), loading: LoadingComponent}),
    "title": "Diagnostic Optivest",
    "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/common/utils/authLegalForm'), loading: LoadingComponent})],
    "exact": true
  },
  {
    "path": "/impersonate",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__impersonate__index' */'@/pages/impersonate/index'), loading: LoadingComponent}),
    "title": "Impersonate User",
    "exact": true
  },
  {
    "path": "/share",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__share__index' */'@/pages/share/index'), loading: LoadingComponent}),
    "title": "recommandations",
    "exact": true
  },
  {
    "path": "/unsubscribe",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__unsubscribe' */'@/pages/unsubscribe'), loading: LoadingComponent}),
    "title": "Unsubscribe email",
    "exact": true
  },
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index' */'@/pages/index'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/",
        "redirect": "/home",
        "exact": true
      },
      {
        "path": "/home",
        "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/utils/authFoDirect'), loading: LoadingComponent})],
        "routes": [
          {
            "path": "/home",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home' */'@/pages/home'), loading: LoadingComponent}),
            "title": "Tableau de bord",
            "exact": true
          },
          {
            "path": "/home/profile",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'modules__profile__pages__profile' */'@/modules/profile/pages/profile'), loading: LoadingComponent}),
            "title": "Profil",
            "exact": true
          },
          {
            "path": "/home/consult",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__consult' */'@/pages/consult'), loading: LoadingComponent}),
            "title": "Contacter mon conseiller personnel",
            "exact": true
          },
          {
            "exact": true,
            "path": "/home/updatePlan",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'modules__subscription__pages__updatePlan' */'@/modules/subscription/pages/updatePlan'), loading: LoadingComponent}),
            "title": "Choisissez votre plan"
          },
          {
            "path": "/home/simulator",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__simulator' */'@/pages/simulator'), loading: LoadingComponent}),
            "title": "Simulateurs",
            "meta": {
              "breadcrumb": "Simulateurs"
            },
            "exact": true
          },
          {
            "path": "/home/reglementation",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'modules__forms__pages__reglementationForm' */'@/modules/forms/pages/reglementationForm'), loading: LoadingComponent}),
            "title": "Formulaire Réglementaire Optivest",
            "exact": true
          },
          {
            "path": "/home/subscription-success",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'modules__subscription__pages__subscriptionSuccess' */'@/modules/subscription/pages/subscriptionSuccess'), loading: LoadingComponent}),
            "title": "Souscription réussie",
            "exact": true
          },
          {
            "path": "/home/upload-documents",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__uploadDocuments' */'@/pages/uploadDocuments'), loading: LoadingComponent}),
            "title": "Téléversement de documents",
            "exact": true
          }
        ]
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
